/**
 * Created by Aleksandr on 16.06.2023
 */

const MSStartSender = function () {
    BaseSender.call(this);

    this.config = {
        maxTimeout: 30
    };
};

MSStartSender.prototype = Object.create(BaseSender.prototype);
MSStartSender.prototype.constructor = MSStartSender;

// TODO: how many PWA players/payers are there?
MSStartSender.prototype.send = function (data, timeout) {
    if (!connector.platform.isConnected()) {
        return;
    }

    if (timeout > connector.utils.parseInterval("7 days")) {
        timeout = connector.utils.parseInterval("7 days");
    }

    // TODO: validate length 60 & 200 chars https://assets.msn.com/staticsb/statics/latest/msstart-games-sdk/documentation/docs/notification-apis/index.html
    const title = data.title;
    const message = data.message;
    const type = data.msstartId !== undefined ? data.msstartId : data.id;
    if (type > MSStartSender.ID_LIMIT) {
        connector.notifications.trigger("stream:error", "Push ID is limited to 0-15 range");
        return;
    }

    // TODO: add image
    const image = undefined;
    const payload = JSON.stringify({ push_code: data.code });
    // TODO: test callToAction, screenshots with/without it
    const callToAction = undefined;

    if (!message) {
        connector.notifications.trigger("stream:error", `empty msstart push - ${data.code}`);
        return;
    }

    $msstart.scheduleNotificationAsync({
        title,
        description: message,
        type,
        imageData: image,
        payload,
        minDelayInSeconds: Math.round(timeout / 1000),
        callToAction
    }).then((response) => {
        console.log(`MSStartSender - ${response}`);
    }).catch((error) => {
        // TODO: add error handling https://assets.msn.com/staticsb/statics/latest/msstart-games-sdk/documentation/docs/notification-apis/index.html
        console.log(`MSStartSender error - ${JSON.stringify(error)}`);
    });

    return true;
};

MSStartSender.prototype.cancel = function () {};

MSStartSender.isAppropriate = function () {
    return connector.platform.oneOf(connector.MSSTART);
};

MSStartSender.ID_LIMIT = 15;